class ResponseErrors extends Error {
  constructor(public errors: Array<string>) {
    super('Response error');
  }
}

export default ResponseErrors;
